/* eslint-disable @typescript-eslint/explicit-function-return-type */
import {
  Grid,
  Paper,
  Typography,
  useTheme,
  Box,
  Modal,
  InputBase,
  IconButton,
  Divider,
} from '@mui/material';
import { colorTheme } from 'theme';
import { useEffect, useState } from 'react';
import SearchIcon from '@mui/icons-material/Search';

import { getAllUserPlanWiseContribution } from 'service/OrderService';
import { CurrencyFormater } from 'components/helpers/commonFunctions/CurrencyFormater';
import { strings } from 'i18n/Strings';

export interface UserPlanContribution {
  contribution: number;
  planName: string;
}

export interface FundsNameType {
  name: string;
}

export interface IGridItemProps {
  title: string;
  value: string | number;
}

const GridItem = (props: IGridItemProps) => {
  const theme = useTheme();
  const colors = colorTheme(theme.palette.mode);

  return (
    <Grid item xs={12} sm={12} md={12} sx={{ display: 'flex', paddingTop: 1 }}>
      <Grid item xs={16}>
        <Typography
          component="h5"
          variant="h5"
          color="#838383"
          fontWeight={500}
          fontSize={17}
          fontFamily="Inter !important"
        >
          {props.title}
        </Typography>
      </Grid>
      <Grid item xs={3}>
        <Typography>:</Typography>
      </Grid>
      <Grid item xs={4} sm={4} md={4}>
        <Typography
          component="h5"
          variant="h5"
          color={colors.gray[100]}
          fontWeight={700}
          fontSize={16}
          fontFamily="Inter !important"
        >
          {props.value}
        </Typography>
      </Grid>
    </Grid>
  );
};

const PlanWiseContribution = (): JSX.Element => {
  const [planUserData, setPlanUserData] = useState<UserPlanContribution[]>([]);
  const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false);
  const [search, setSearch] = useState('');

  const theme = useTheme();
  const colors = colorTheme(theme.palette.mode);

  const getAllPlanContribution = async (): Promise<void> => {
    try {
      const data = await getAllUserPlanWiseContribution();
      setPlanUserData(data);
    } catch (error) {
      console.log(error);
    }
  };

  const ConfirmationDialog = (): JSX.Element => {
    return (
      <Modal
        open={openConfirmationDialog}
        onClose={() => {
          setOpenConfirmationDialog(false);
        }}
      >
        <Box
          sx={{
            position: 'absolute' as const,
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',

            bgcolor: 'background.paper',
            boxShadow: 24,
            py: 5,
            px: 5,
            borderRadius: 5,
          }}
        ></Box>
      </Modal>
    );
  };

  useEffect(() => {
    void getAllPlanContribution();
  }, []);

  return (
    <Box>
      <Box
        display="flex"
        bgcolor={'#fff'}
        borderRadius={'3px'}
        marginRight={3}
        style={{ width: '450px', float: 'right' }}
      >
        <InputBase
          sx={{ ml: 2, flex: 1, width: '350px' }}
          placeholder={strings.displayText.searchPlanName}
          onChange={(e: unknown) => {
            setSearch(e.target.value);
          }}
        />

        <IconButton type="button" sx={{ p: 1 }}>
          <SearchIcon />
        </IconButton>
      </Box>
      <Paper
        sx={{
          margin: 'auto',
          maxWidth: 1200,
          flexGrow: 1,
        }}
      >
        {planUserData
          .filter((plan) =>
            plan.planName.toLowerCase().includes(search.toLowerCase()),
          )
          .map((planUser, idx) => (
            <Grid
              key={`planUser-${idx}`}
              container
              item
              xs={12}
              sm={12}
              md={12}
            >
              <Grid item xs={2} sm={2} md={2}>
                <Box
                  sx={{
                    padding: 2,
                  }}
                >
                  <Typography
                    component="h5"
                    variant="h5"
                    color={colors.greenAccent[500]}
                    fontWeight={800}
                    fontSize={17}
                    fontFamily="Inter !important"
                    sx={{
                      textAlign: 'center',
                      marginBlock: 2,
                    }}
                  >
                    {planUser.planName}
                  </Typography>
                  <Box marginBottom={5}></Box>
                </Box>
              </Grid>

              <Grid item xs={4} sm={8} md={8} sx={{ marginBlock: 2 }}>
                <Box marginTop={1}></Box>
                {Object.keys(planUser)
                  .filter((key) => !['planName', 'contribution'].includes(key))
                  .map((fund: string, idx) => (
                    <GridItem
                      key={`fund-${idx}`}
                      title={fund}
                      value={CurrencyFormater(Number(planUser[fund])) || '-'}
                    />
                  ))}
                <Divider sx={{ marginBlock: 2 }} />
              </Grid>
            </Grid>
          ))}
      </Paper>
      <ConfirmationDialog />
    </Box>
  );
};

export default PlanWiseContribution;
